import { render, staticRenderFns } from "./channeLabel.vue?vue&type=template&id=36d1f8c8&scoped=true"
import script from "./channeLabel.vue?vue&type=script&lang=js"
export * from "./channeLabel.vue?vue&type=script&lang=js"
import style0 from "./channeLabel.vue?vue&type=style&index=0&id=36d1f8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1f8c8",
  null
  
)

export default component.exports